// extracted by mini-css-extract-plugin
export var client = "worknextprev-module--client--s+0Yj";
export var next = "worknextprev-module--next--xG2I4";
export var prev = "worknextprev-module--prev--oIBiG";
export var wrap = "worknextprev-module--wrap--8BYax";